import { Box, useTheme } from "@mui/material";
import { useState } from "react";
import DashboardCard from "../DashboardCard";

export default function ProjectCounters() {
    const theme = useTheme();

    const [isEditProjectSummary, setIsEditProjectSummary] = useState(false);

    const [projectSummary, setProjectSummary] = useState("Project Summary: Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio.");

    let list = [
        // {
        //     title: "User Story",
        //     type: "counter",
        //     data: 7454,

        // },
        {
            title: "Priority",
            type: "doughnut",
            data: {
                labels: ["HIGH", "MEDIUM", "LOW",],
                datasets: [
                    {
                        label: '',
                        data: [12, 19, 45,]
                    },

                ],
                colorsList: ["#7d7d8d", "#3f5gd1", "#ff9800",]
            },

        },
        {
            title: "State",
            type: "doughnut",
            data: {
                labels: ['DRAFT', 'INPROGRESS', 'APPROVED', "COMPLETED", "CLOSED"],
                datasets: [
                    {
                        label: '',
                        data: [32, 40, 28, 30, 50],
                    },
                ],
                colorsList: ["#7d7d8d", "#3f5gd1", "#ff9800", "#4caf50", "#2196f3"]
            },

        },
        {
            title: "Type",
            type: "doughnut",
            data: {
                labels: ['PROCESS', 'FUNCTIONAL', 'NON-FUNCTIONAL',],
                datasets: [
                    {
                        label: '',
                        data: [32, 40, 28],
                    },
                ],
                colorsList: ["#7d7d8d", "#3f5gd1", "#ff9800",]
            },

        },
        {
            title: "Moscow",
            type: "doughnut",
            data: {
                labels: ['MUST', 'SHOULD', 'COULD', 'WONT'],
                datasets: [
                    {
                        label: '',
                        data: [25, 50, 20, 5],
                    },
                ],
                colorsList: ["#7d7d8d", "#3f5gd1", "#ff9800", "#2196f3"]
            },

        },
        {
            title: "Confidentiality",
            type: "doughnut",
            data: {
                labels: ['CONFIDENTIAL', 'SENSITIVE', 'UNCLASSIFIED',],
                datasets: [
                    {
                        label: '',
                        data: [25, 30, 20],
                    },
                ],
                colorsList: ["#7d7d8d", "#3f5gd1", "#ff9800", "#4caf50"]
            },

        },

    ];


    return (
        <Box className="flex gap-4 w-full h-full">

            <Box className="flex-1 flex flex-col gap-0 overflow-y-auto">
                <Box className={`grid grid-cols-1  sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 pl-0 py-0`}>
                    {
                        list?.map((item, index) => {
                            return (
                                <Box
                                    key={index}
                                    className={` overflow-hidden rounded-lg border hover:shadow-2xl  backdrop-blur-md transition-all ease-in-out duration-300 
                                                        h-[320px]
                                                 `}
                                    bgcolor={theme.palette.card.main}
                                // onClick={() => handleOpenProject(project)}
                                >
                                    <DashboardCard
                                        item={item}
                                    />

                                </Box>
                            )
                        })
                    }
                </Box>
            </Box>



        </Box>
    )
}